import React from 'react'
import {ConversationMessage} from "../../../types/Conversation";
import {Transition} from "@headlessui/react";

// Types ----

type AssistantProps = {
  message: ConversationMessage
}

// Component ----

function AssistantMessage({message}: AssistantProps) {
  return (
    <Transition
      appear
      enter="transition-all duration-300"
      enterFrom="opacity-0 translate-y-2"
      enterTo="opacity-100 translate-y-0"
    >
      <div className='flex flex-col gap-2 group px-2 py-3'>
        <p>{message.content}</p>

        <p className='flex justify-end text-xs text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200'>
          {message.tokens_used.toLocaleString()} tokens used {message.role === 'assistant' ? ` (${message.tokens.cached.toLocaleString()} from cache)` : ''}
        </p>
      </div>
    </Transition>
  );
}

export {AssistantMessage};